export function isHospitalAtc(caseRecord) {
    return caseRecord?.hospital?.atc?.toLowerCase() === 'si'
}

export function isNotHospitalAtc(caseRecord) {
    return caseRecord?.hospital?.atc?.toLowerCase() === 'no'
}
